import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import { breakpoint, pxToRem, size } from '@twistopayments/design-system/styles'

export const wrap = css`
  display: flex;
  flex-direction: column;
  margin: ${size[24]};

  ${breakpoint.up('md')} {
    margin: ${size[80]} ${size[120]};
    flex-direction: row;
  }
`

export const listOuter = css`
  overflow: hidden;
  flex-shrink: 0;
`

export const list = (gap: number) => css`
  display: flex;
  transition: transform 500ms ease-in-out;
  gap: ${gap}px;
`

export const slide = (theme: Theme) => css`
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: ${size[24]};
  align-items: start;
  padding: ${size[16]};
  border-radius: ${theme.borderRadius.md};
  border: 1px solid ${theme.palette.tertiary.mediumContrast};
  width: 100%;

  ${breakpoint.up('md')} {
    flex-direction: row;
    align-items: center;
    gap: ${size[64]};
    padding: 0;
    padding-inline-end: ${size[64]};
    border: none;
    width: initial;
  }
`

export const img = (theme: Theme) => css`
  border-radius: ${theme.borderRadius.lg};
  align-self: center;

  ${breakpoint.up('md')} {
    align-items: initial;
    height: 690px;
    width: 506px;
  }
`

export const nav = css`
  ${breakpoint.up('md')} {
    margin-inline-end: ${size[128]};
  }
`

export const links = (theme: Theme) => css`
  display: none;
  flex-direction: column;
  gap: ${size[24]};
  color: ${theme.palette.tertiary.mediumContrastAlternative};
  font-weight: 400;
  font-size: ${pxToRem(21)};
  letter-spacing: 0.02rem;

  ${breakpoint.up('md')} {
    display: flex;
  }
`

export const navItem = (theme: Theme) => css`
  color: ${theme.palette.tertiary.mediumContrastAlternative};
  font-weight: 400;
  font-size: ${pxToRem(21)};
  letter-spacing: 0.02rem;
  padding: 0;
  text-align: start;
  cursor: pointer;
  border: none;
  background-color: transparent;
`

export const buttons = (theme: Theme) => css`
  margin-bottom: ${size[32]};
  display: flex;
  justify-content: end;
  gap: ${size[32]};

  button {
    color: ${theme.palette.primary.mainContrast};
    border: none;
    background: transparent;
    cursor: pointer;
    padding: 0;

    &:first-of-type {
      transform: rotate(180deg);
    }
  }

  ${breakpoint.up('md')} {
    justify-content: start;
    margin-bottom: ${size[64]};
  }
`

export const text = css`
  height: fit-content;
  letter-spacing: 0.02rem;

  ${breakpoint.up('md')} {
    width: 430px;
  }
`

export const title = (theme: Theme) => css`
  font-weight: 500;
  font-size: ${size[18]};
  line-height: ${pxToRem(20)};
  letter-spacing: 0.02rem;
  margin-bottom: ${size[16]};
  color: ${theme.palette.text.title};

  ${breakpoint.up('md')} {
    font-size: ${size[32]};
    margin-bottom: ${size[24]};
    line-height: ${pxToRem(36)};
  }
`

export const desc = (theme: Theme) => css`
  font-weight: 400;
  font-size: ${pxToRem(17)};
  line-height: 24px;
  color: ${theme.palette.tertiary.mediumContrastAlternative};

  ${breakpoint.up('md')} {
    font-size: ${pxToRem(22)};
    line-height: 1em;
  }
`
